import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Textarea,
    Stack,
    VStack,
    Select,
    Link,
    Progress,
    Checkbox,
    Tooltip, Spinner,
    Divider, PopoverCloseButton, PopoverBody, useDisclosure, useInterval, Icon, keyframes,
    useToast, IconButton, Grid, GridItem, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel,
    TableContainer, Tfoot, useMediaQuery, Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow,
    FormControl, FormLabel,
    Spacer, Collapse, Badge
} from '@chakra-ui/react';
import React, { useState, useRef, useEffect, useMemo, memo } from 'react';
import ProdutoImagem from "../ProdutoImagem";
import ListaCompraStatusBadge from "../ListaCompraStatusBadge";
import AdicionarItemListaModal from "../AdicionarItemListaModal";
import { FiMoreVertical, FiPlus, FiMinus } from 'react-icons/fi';
import { GoPackage } from "react-icons/go";
import { MdLocalShipping, MdCancel, MdNoteAdd, MdLocalOffer } from "react-icons/md";
import { IoMdSend, IoMdCart, IoMdChatboxes, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaCopy, FaEllipsisV, FaEye, FaBox, FaSearch, FaCartArrowDown, FaMap, FaFileAlt, FaCommentDots, FaClipboardCheck, FaCheckSquare, FaTrash, FaCheckCircle, FaBackspace, FaFilter, FaDownload, FaFileInvoice, FaInfoCircle, FaExclamationTriangle } from 'react-icons/fa';
import {
    getVendasML, setVendaCotacao, getVenda, setFuroEstoqueVenda, setStatusTaga, criarObsVenda, apagarObsVenda, getMensagemVenda,
    enviarMensagemVenda, atualizarVendas, setMarcadorVenda, imprimirEtiquetaML, emitirNfML, consultarRetornoProcessamento,
    setStatusVenda, getVendaManual, createTicket, emitirNfeTaga, downloadNfeArquivo, atualizarClienteVenda,
    atualizarDataLimiteEnvio, getDadosEntregaCombinar, confirmarEntregaCombinar
} from "../../services/api";
import PreloaderMini from "../../components/PreloaderMini";
import Notas from "../../components/Notas";
import MarcadoresVenda from "../../components/MarcadoresVenda";
import { formatDistanceToNow, parse, parseISO, isToday, isBefore, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import $ from 'jquery';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { MdCheck, MdEdit, MdStar } from 'react-icons/md';
import { FaBookmark, FaBoxOpen, FaCarCrash, FaExternalLinkAlt, FaTruckLoading } from "react-icons/fa";
import { MdDoNotDisturb, MdMoneyOff, MdErrorOutline, MdImageNotSupported } from "react-icons/md";
import { isColetaMl } from "../../utils/envioMl";
import { checkPermission, checkPermissionUser } from "../../services/permission";
import { AiFillDollarCircle } from "react-icons/ai";
import { DateTime } from "luxon";
import StatusConferenciaBadge from "../../components/StatusConferenciaBadge";
import { useAcoesItemVenda, SelosOcorrenciasItem, LinhasExtrato, itemForaDoPedido } from "../OcorrenciasItemVenda";
import { CONTAS_ML } from "../VendaCardV2/ui";

import GeradorEtiquetaMelhorEnvio from '../../components/GeradorEtiquetaMelhorEnvio';

import '../../index.css';

const estiloPadraoP = {
    display: 'initial',
    marginBlockStart: 'initial',
    marginBlockEnd: 'initial',
    marginInlineStart: 'initial',
    marginInlineEnd: 'initial',
    unicodeBidi: 'initial'
};

// --- FUNÇÕES AUXILIARES (Movidas do Vendas.js para cá) ---
function limitarCaracteres(str, limite) {
    if (str?.length && str.length > limite) {
        return str.slice(0, limite) + "...";
    }
    return str;
}

const formatarMoedaOcorrencia = (valor) => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const LinhaExtratoAntigo = ({ rotulo, valor, negativo }) => (
    <Flex py="0.5">
        <Spacer />
        <Box w="150px">
            <Text textAlign="end">{rotulo}</Text>
        </Box>
        <Box w="100px">
            <Text textAlign="center">{formatarMoedaOcorrencia(negativo ? -valor : valor)}</Text>
        </Box>
    </Flex>
);

const getBgPedidoStatusTAGA = (pedido) => {
    if (pedido.status_taga == 1) { return "green.300"; }
    if (pedido.status_taga == 2) { return "red.300"; }
    if (pedido.status_taga == 3) { return "yellow.300"; }
    return "";
};

const getTextPedidoStatusTAGA = (pedido) => {
    if (pedido.status_taga == 1) { return "CONFIRMADA"; }
    if (pedido.status_taga == 2) { return "CANCELADA"; }
    if (pedido.status_taga == 3) { return "PENDENTE"; }
    return "";
};

const getBgPrazoEnvio = (data) => {
    if (typeof data !== 'string' || !data.includes(' ') || data.split(' ').length < 2) {
        return "gray.200";
    }
    try {
        const prazo = DateTime.fromFormat(data, "dd/MM/yyyy HH:mm", { zone: "America/Sao_Paulo" });
        if (!prazo.isValid) return "gray.200";
        const agora = DateTime.now().setZone("America/Sao_Paulo");
        if (prazo < agora) return "red.300";
        else return "yellow.300";
    } catch (e) {
        return "gray.200";
    }
};

const getBgBasedOnStatus = (status) => {
    if (status == "CONFIRMADA") return "gray.600";
    else if (status == "PARA ENVIAR") return "yellow.200";
    else if (status == "EM TRÂNSITO") return "blue.500";
    else if (status == "CONCLUÍDA") return "green.500";
    else if (status == "CANCELADA") return "red.500";
};

const getColorBasedOnBg = (color) => {
    if (color == "yellow.200") return "black";
    else return "white";
};

const getIconPedidoStatus = (status) => {
    if (status == "CONFIRMADA") return <IoMdCart fontSize={"15px"} style={{ marginRight: "5px" }} />;
    else if (status == "PARA ENVIAR") return <GoPackage fontSize={"18px"} style={{ marginRight: "5px" }} />;
    else if (status == "EM TRÂNSITO") return <MdLocalShipping fontSize={"18px"} style={{ marginRight: "5px" }} />;
    else if (status == "CONCLUÍDA") return <FaCheckCircle fontSize={"15px"} style={{ marginRight: "5px" }} />;
    else if (status == "CANCELADA") return <MdCancel fontSize={"18px"} style={{ marginRight: "5px" }} />;
};

const getBgPedidoStatus = (pedido) => {
    var color = "#ffc499";
    if (pedido.marcador == 1) color = "red.300";
    else if (pedido.marcador == 2) color = "yellow.300";
    else if (pedido.marcador == 3) color = "gray.400";
    else if (pedido.marcador == 4) color = "purple.300";
    else if (pedido.marcador == 5) color = "blue.400";
    else if (pedido.marcador == 6) color = "orange.300";
    return color;
};

const getIconMarcador = (pedido) => {
    if (pedido.marcador == 1) return <FaBoxOpen color="black" />;
    else if (pedido.marcador == 2) return <MdDoNotDisturb color="black" />;
    else if (pedido.marcador == 3) return <MdLocalShipping color="black" />;
    else if (pedido.marcador == 4) return <MdMoneyOff color="black" />;
    else if (pedido.marcador == 5) return <MdErrorOutline color="black" />;
    else if (pedido.marcador == 6) return <MdImageNotSupported color="black" />;
    return "";
};

const getTextoMarcador = (pedido) => {
    if (pedido.marcador == 1) return "FURO DE ESTOQUE";
    else if (pedido.marcador == 2) return "VENDA COM PENDÊNCIAS";
    else if (pedido.marcador == 3) return "PROBLEMA NO ENVIO";
    else if (pedido.marcador == 4) return "ERRO DE PRECIFICAÇÃO";
    else if (pedido.marcador == 5) return "OUTROS PROBLEMAS";
    else if (pedido.marcador == 6) return "PRODUTO DIFERENTE";
    return "";
};

function getImagemFornecedor(fornecedor) {
    var imagem = "/logo_vannucci.webp"
    if (fornecedor == "MORELATE") imagem = "/logo_morelate.webp";
    else if (fornecedor == "ISAPA") imagem = "/logo_isapa.webp";
    else if (fornecedor == "BRCOMPANY") imagem = "/logo_brcompany.webp";
    else if (fornecedor == "AUTOLATINA") imagem = "/logo_autolatina.webp";
    else if (fornecedor == "LNG") imagem = "/logo_lng.webp";
    else if (fornecedor == "CBA") imagem = "/logo_cba.webp";
    else if (fornecedor == "MSAM") imagem = "/logo_msam.webp";
    else if (fornecedor == "BLPARTS") imagem = "/logo_blparts.webp";
    return imagem;
}


/**
 * Tooltip que não é montado no celular.
 *
 * Cada linha da lista de vendas tem 29 tooltips. Com as ~156 vendas que a tela
 * costuma carregar, isso vira mais de 4 mil instâncias, cada uma com o seu
 * posicionador e os seus ouvintes de evento. É um dos maiores consumidores de
 * memória da tela, e no Safari do iPhone o consumo alto derruba a aba
 * ("Um problema ocorreu repetidamente", ticket #2299).
 *
 * No celular o tooltip praticamente não serve: ele depende de passar o mouse
 * por cima. Então lá o componente sai do caminho e o filho é renderizado
 * direto, sem alterar layout, clique ou qualquer outro comportamento.
 *
 * Isto NÃO afeta modal, popover ou menu: só o balãozinho de dica.
 */
const TooltipSePuder = ({ desativado, children, ...props }) =>
    desativado ? children : <Tooltip {...props}>{children}</Tooltip>;

const normalizarTipoCliente = (tipo) => {
    if (tipo === 2 || tipo === '2' || tipo === 'PJ') return 'PJ';
    if (tipo === 1 || tipo === '1' || tipo === 'PF') return 'PF';
    return 'PF';
};

const VendaItem = ({
    pedido,
    index,
    isMobile,
    checkboxesState,
    handleCheckboxChange,
    menuVisivel,
    toggleMenu,
    handleCotacaoVenda,
    handleChangeAcaoIndiv,
    openTicketModal,
    handleAddObs,
    handleChangeTextObs,
    textObs,
    handleApagarObs,
    handleMarcadorTaga,
    consultarMensagensVendas,
    naoLidasPorPackId = {},
    openModalViewPedido,
    openModalViewPedidoTaga,
    handleClickCopyPedido,
    handleClickCopyAnuncio,
    loadingItemsEtiqueta,
    handleClickImprimirEtiqueta,
    loadingItemsNFML,
    openModalConfirmNF,
    openModalConfirmNfeTaga,
    openPedidosFooter,
    toggleAccordionPedidosFooter,
    checkPermission,
    checkPermissionUser,
    loadingMini,
    isLastItem,
    isInPackGroup = false,
    cotacaoStatus,
    onOcorrenciasAlteradas,
}) => {

    const listaRef = useRef(null);
    const buttonRef = useRef(null);

    const [expandedProducts, setExpandedProducts] = useState({});
    const acoesItem = useAcoesItemVenda({ onAlterado: onOcorrenciasAlteradas });

    // --- Estado do modal de edição de cliente ---
    const toast = useToast();
    const [localCliente, setLocalCliente] = useState(null);
    const { isOpen: isClienteModalOpen, onOpen: onClienteModalOpen, onClose: onClienteModalClose } = useDisclosure();
    const [clienteForm, setClienteForm] = useState({ nome: '', nickname: '', tipo: 'PF', documento: '', ie: '', email: '', telefone: '' });
    const [savingCliente, setSavingCliente] = useState(false);

    // --- Estado do modal de confirmação de dados de entrega (Entrega a Combinar) ---
    const { isOpen: isEntregaModalOpen, onOpen: onEntregaModalOpen, onClose: onEntregaModalClose } = useDisclosure();
    const [entregaForm, setEntregaForm] = useState({ nome: '', telefone: '', documento: '', tipo: 'PF', cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '', transportadora: '' });
    const [savingEntrega, setSavingEntrega] = useState(false);
    const [loadingEntrega, setLoadingEntrega] = useState(false);
    const isEntregaCombinar = pedido?.envio?.modo_envio === 'Entrega a Combinar';

    // Selo de aviso de entrega ao Mercado Livre. Enquanto o ML nao e avisado, o
    // pedido fica em "Combine a entrega" e o dinheiro nao e liberado — por isso
    // vale mostrar na linha da venda que o aviso ja saiu (ou que falhou).
    const avisoEntregaMl = useMemo(() => {
        if (pedido?.ml_entrega_avisada_at) {
            let quando = '';
            try {
                quando = format(parseISO(pedido.ml_entrega_avisada_at.replace(' ', 'T')), "dd/MM/yyyy 'às' HH:mm");
            } catch {
                quando = '';
            }
            return {
                rotulo: 'ENTREGA AVISADA NO ML',
                descricao: quando
                    ? `Entrega confirmada no Mercado Livre em ${quando}. O pagamento foi liberado.`
                    : 'Entrega confirmada no Mercado Livre. O pagamento foi liberado.',
                icone: FaCheckCircle,
                cor: 'green.700',
                bg: 'green.50',
                borda: 'green.200',
            };
        }

        if (pedido?.ml_entrega_aviso_erro) {
            return {
                rotulo: 'FALHA AO AVISAR O ML',
                descricao: `Não foi possível avisar a entrega ao Mercado Livre: ${pedido.ml_entrega_aviso_erro}. O sistema tenta de novo automaticamente.`,
                icone: FaExclamationTriangle,
                cor: 'red.700',
                bg: 'red.50',
                borda: 'red.200',
            };
        }

        return null;
    }, [pedido?.ml_entrega_avisada_at, pedido?.ml_entrega_aviso_erro]);

    const clienteAtual = localCliente ?? pedido?.dados_cliente;

    // --- Indicadores do botão de chat ML ---
    const statusMsg = naoLidasPorPackId[String(pedido?.pack_id)] || {};
    const msgQtdNaoLidas = statusMsg.qtd || 0;
    const msgTemNaoLida = !!statusMsg.nao_lida;
    const msgTemHistorico = !!statusMsg.tem_historico;
    // Laranja = ja tem conversa; cinza claro = sem mensagens.
    const msgBotaoBg = msgTemHistorico ? "#eb9659" : "gray.200";
    const msgTooltipLabel = msgTemNaoLida
        ? (msgQtdNaoLidas > 0
            ? `${msgQtdNaoLidas} mensagem(ns) não lida(s)`
            : 'Mensagens não lidas')
        : (msgTemHistorico ? 'Chat com mensagens' : 'Chat com Cliente');
    const msgBadge = msgTemNaoLida ? (
        <Box
            position="absolute"
            top="-4px"
            right="-4px"
            bg="red.500"
            color="white"
            borderRadius="full"
            minW="16px"
            h="16px"
            fontSize="9px"
            fontWeight="bold"
            lineHeight="1"
            display="flex"
            alignItems="center"
            justifyContent="center"
            px="3px"
            border="1.5px solid white"
        >
            {msgQtdNaoLidas > 0 ? (msgQtdNaoLidas > 99 ? '99+' : msgQtdNaoLidas) : '•'}
        </Box>
    ) : null;

    const [localDataLimiteEnvio, setLocalDataLimiteEnvio] = useState(null);
    const { isOpen: isPrazoModalOpen, onOpen: onPrazoModalOpen, onClose: onPrazoModalClose } = useDisclosure();
    const { isOpen: isPrazoConfirmOpen, onOpen: onPrazoConfirmOpen, onClose: onPrazoConfirmClose } = useDisclosure();
    const [prazoForm, setPrazoForm] = useState("");
    const [prazoConfirmacaoTexto, setPrazoConfirmacaoTexto] = useState("");
    const [savingPrazo, setSavingPrazo] = useState(false);

    const dataLimiteEnvioAtual = localDataLimiteEnvio ?? pedido?.data_limite_envio;

    // Modal "Sem Lista"/"Ignorado" + overrides otimistas por item_venda_id
    const [modalListaInfo, setModalListaInfo] = useState(null);
    const [listaStatusOverrides, setListaStatusOverrides] = useState({});

    const handleOpenListaModal = (produto, statusAtual) => {
        if (!produto?.item_venda_id || !produto?.fornecedor_id) return;
        setModalListaInfo({
            itemVendaId: produto.item_venda_id,
            fornecedorId: produto.fornecedor_id,
            fornecedorNome: produto.fornecedor,
            produtoNome: produto.nome,
            statusAtual,
        });
    };

    const handleListaUpdated = (novoStatus) => {
        if (!modalListaInfo) return;
        const itemId = modalListaInfo.itemVendaId;
        setListaStatusOverrides((prev) => ({
            ...prev,
            [itemId]: novoStatus && novoStatus.status ? novoStatus : null,
        }));
    };

    const resolverListaStatus = (produto) => {
        const itemId = produto?.item_venda_id;
        if (itemId && Object.prototype.hasOwnProperty.call(listaStatusOverrides, itemId)) {
            return listaStatusOverrides[itemId];
        }
        return produto?.lista_compra_status ?? null;
    };

    const handleOpenClienteModal = () => {
        setClienteForm({
            nome: clienteAtual?.nome || '',
            nickname: clienteAtual?.nickname || '',
            tipo: normalizarTipoCliente(clienteAtual?.tipo),
            documento: clienteAtual?.documento || '',
            ie: clienteAtual?.ie || '',
            email: clienteAtual?.email || '',
            telefone: clienteAtual?.telefone || '',
        });
        onClienteModalOpen();
    };

    const handleSalvarCliente = async () => {
        if (!clienteForm.nome?.trim()) {
            toast({ title: 'Nome é obrigatório', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        setSavingCliente(true);
        try {
            const res = await atualizarClienteVenda(pedido.id_taga ?? pedido.id, clienteForm);
            if (res?.data?.status) {
                setLocalCliente(res.data.data);
                onClienteModalClose();
                toast({ title: 'Cliente atualizado com sucesso', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao salvar cliente', description: res?.data?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao salvar cliente', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingCliente(false);
        }
    };

    const handleOpenEntregaModal = async () => {
        const c = clienteAtual || {};
        const mapTipo = (t) => (t === 2 || t === '2' || t === 'PJ') ? 'PJ' : 'PF';
        setEntregaForm({
            nome: c.nome || c.nickname || '',
            telefone: c.telefone || '',
            documento: c.documento || '',
            tipo: mapTipo(c.tipo),
            cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '',
            transportadora: pedido?.transportadora_combinada || '',
        });
        onEntregaModalOpen();
        setLoadingEntrega(true);
        try {
            const res = await getDadosEntregaCombinar(pedido.id_taga ?? pedido.id);
            if (res?.data?.status) {
                const { cliente, endereco, transportadora_combinada } = res.data.data;
                setEntregaForm({
                    nome: cliente?.nome || cliente?.nickname || c.nome || c.nickname || '',
                    telefone: cliente?.telefone || c.telefone || '',
                    documento: cliente?.documento || c.documento || '',
                    tipo: mapTipo(cliente?.tipo ?? c.tipo),
                    cep: endereco?.cep || '',
                    endereco: endereco?.endereco || '',
                    numero: endereco?.numero || '',
                    complemento: endereco?.complemento || '',
                    bairro: endereco?.bairro || '',
                    cidade: endereco?.cidade || '',
                    uf: endereco?.uf || '',
                    transportadora: transportadora_combinada || pedido?.transportadora_combinada || '',
                });
            }
        } catch (e) {
            // mantém o que já foi pré-preenchido a partir do clienteAtual
        } finally {
            setLoadingEntrega(false);
        }
    };

    const handleSalvarEntrega = async () => {
        if (!entregaForm.nome?.trim()) {
            toast({ title: 'Nome é obrigatório', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        setSavingEntrega(true);
        try {
            const res = await confirmarEntregaCombinar(pedido.id_taga ?? pedido.id, entregaForm);
            if (res?.data?.status) {
                const { cliente, transportadora_combinada } = res.data.data;
                pedido.status_taga = 1;
                pedido.furo_estoque = 0;
                pedido.marcador = 0;
                pedido.transportadora_combinada = transportadora_combinada;
                setLocalCliente(cliente);
                onEntregaModalClose();
                toast({ title: 'Dados de entrega confirmados', description: 'Venda marcada como CONFIRMADA', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao confirmar entrega', description: res?.data?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao confirmar entrega', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingEntrega(false);
        }
    };

    const handleOpenPrazoModal = () => {
        const atual = dataLimiteEnvioAtual;
        let initial = "";
        if (typeof atual === 'string' && atual.includes('/')) {
            const match = atual.match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})/);
            if (match) {
                const [, d, m, y, hh, mm] = match;
                initial = `${y}-${m}-${d}T${hh}:${mm}`;
            }
        }
        setPrazoForm(initial);
        onPrazoModalOpen();
    };

    const handleConfirmarPrazo = () => {
        if (!prazoForm) {
            toast({ title: 'Informe a nova data', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        const agora = new Date();
        const escolhida = new Date(prazoForm);
        if (isNaN(escolhida.getTime())) {
            toast({ title: 'Data inválida', status: 'error', duration: 3000, isClosable: true });
            return;
        }
        if (escolhida <= agora) {
            toast({ title: 'A data precisa ser no futuro', status: 'warning', duration: 3000, isClosable: true });
            return;
        }
        const dataFormatada = escolhida.toLocaleString('pt-BR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
        setPrazoConfirmacaoTexto(dataFormatada);
        onPrazoConfirmOpen();
    };

    const handleSalvarPrazo = async () => {
        setSavingPrazo(true);
        try {
            const idVenda = pedido.id_taga ?? pedido.id;
            const res = await atualizarDataLimiteEnvio(idVenda, prazoForm);
            if (res?.success) {
                const novoDisplay = res.data_limite_envio_display;
                setLocalDataLimiteEnvio(novoDisplay);
                pedido.data_limite_envio = novoDisplay;
                if (pedido.envio) {
                    pedido.envio.data_limite_envio = res.data_limite_envio;
                }
                onPrazoConfirmClose();
                onPrazoModalClose();
                toast({ title: 'Prazo de envio atualizado', status: 'success', duration: 3000, isClosable: true });
            } else {
                toast({ title: 'Erro ao salvar prazo', description: res?.error || '', status: 'error', duration: 4000, isClosable: true });
            }
        } catch (e) {
            toast({ title: 'Erro ao salvar prazo', status: 'error', duration: 4000, isClosable: true });
        } finally {
            setSavingPrazo(false);
        }
    };

    const handleToggleProductDetails = (pedidoId, produtoId) => {
        setExpandedProducts(prev => ({
            ...prev,
            [produtoId]: !prev[produtoId]
        }));
    };

    const isProductExpanded = (pedidoId, produtoId) => {
        return !!expandedProducts[produtoId];
    };

    useEffect(() => {
        if (menuVisivel !== pedido.id) return;

        const fecharMenuAoClicarFora = (event) => {
            if (listaRef.current && !listaRef.current.contains(event.target) &&
                buttonRef.current && !buttonRef.current.contains(event.target)) {

                toggleMenu(pedido.id);
            }
        };

        document.addEventListener('mousedown', fecharMenuAoClicarFora);
        return () => {
            document.removeEventListener('mousedown', fecharMenuAoClicarFora);
        };
    }, [menuVisivel, pedido.id, toggleMenu]);

    return (
        <>
        <Flex maxW="100%" w="100%" justifyContent={"center"} align={"center"} >
            {
                !isMobile && (
                    <Flex flexDirection={"column"}>
                        <Notas handleAddObs={handleAddObs} idVenda={pedido.id_taga} handleChangeTextObs={handleChangeTextObs} textObs={textObs} observacoes={pedido.observacoes} handleApagarObs={handleApagarObs} />
                        {checkPermission() && <MarcadoresVenda onOptionClick={handleMarcadorTaga} idVenda={pedido.id_taga} marcadorAtual={pedido.marcador} />}
                    </Flex>
                )
            }
            <Flex w={{ base: "100%" }} borderRadius="lg" justifyContent={"center"} align={"center"} mb={isInPackGroup ? 1 : 4} key={pedido.id}>
                <Flex className='box-op' justifyContent={"center"} w={"100%"} flexDirection={"column"} >
                    <Flex flexWrap="wrap" alignItems="center">
                        {
                            pedido.status_taga != 0 &&
                            (

                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Status TAGA">
                                    <Box
                                        ml={3}
                                        bg={getBgPedidoStatusTAGA(pedido)}
                                        w={"100px"}
                                        h={"15px"}
                                        transform="perspective(20px) rotateX(15deg)"
                                        overflow="hidden"
                                    >
                                        <Text fontWeight={"bold"} color={pedido.status_taga == 3 ? "black" : "white"} fontSize={"12px"} transform="perspective(20px) rotateX(-15deg)">{getTextPedidoStatusTAGA(pedido)}</Text>
                                    </Box>
                                </TooltipSePuder>
                            )
                        }
                        <Box position="relative" mt={-0.3} ml={6}>
                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Prazo de Envio">
                                <Box
                                    bg={getBgPrazoEnvio(dataLimiteEnvioAtual)}
                                    w={{ base: "195px", md: "185px" }}
                                    h={"15px"}
                                    transform="perspective(20px) rotateX(15deg)"
                                    overflow="hidden"
                                    pr={5}
                                >
                                    <Text fontWeight={"bold"} color={"black"} fontSize={"11px"} transform="perspective(20px) rotateX(-15deg)">Enviar até {dataLimiteEnvioAtual}</Text>
                                </Box>
                            </TooltipSePuder>
                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Editar prazo de envio">
                                <Box
                                    as="button"
                                    type="button"
                                    position="absolute"
                                    right="2px"
                                    top="0"
                                    bottom="0"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    px={1}
                                    cursor="pointer"
                                    onClick={(e) => { e.stopPropagation(); handleOpenPrazoModal(); }}
                                    _hover={{ opacity: 0.6 }}
                                    aria-label="Editar prazo de envio"
                                >
                                    <Icon as={MdEdit} boxSize="11px" color="black" />
                                </Box>
                            </TooltipSePuder>
                        </Box>
                        {cotacaoStatus && cotacaoStatus.token && (() => {
                            const map = {
                                aguardando_envio:   { label: "Aguardando envio",   colorScheme: "gray"   },
                                aguardando_resposta:{ label: "Aguardando resposta",colorScheme: "yellow" },
                                sem_estoque:        { label: "Sem estoque",        colorScheme: "red"    },
                                disponivel:         { label: "Disponível",         colorScheme: "green"  },
                            };
                            const cfg = map[cotacaoStatus.status];
                            if (!cfg) return null;
                            return (
                                <TooltipSePuder desativado={isMobile} openDelay={300} isLazy label="Ver cotação">
                                    <Badge
                                        as="button"
                                        type="button"
                                        ml={3}
                                        colorScheme={cfg.colorScheme}
                                        fontSize="11px"
                                        px={2}
                                        h="15px"
                                        lineHeight="15px"
                                        borderRadius="sm"
                                        cursor="pointer"
                                        onClick={(e) => { e.stopPropagation(); window.open(`/cotacoes/${cotacaoStatus.token}`, '_blank', 'noopener'); }}
                                    >
                                        Cotação: {cfg.label}
                                    </Badge>
                                </TooltipSePuder>
                            );
                        })()}
                    </Flex>
                    <Box boxShadow='lg' borderRadius="lg" justifyItems={"center"} w={"100%"} bg={getBgPedidoStatus(pedido)}>
                        <Flex w="100%" flexDirection={{ base: "column", md: "row", lg: "row" }} borderTopRadius="lg" justify={{ base: "center", md: "center", lg: "space-between" }} bg={"#edae80"}>
                            <Flex justify={{ base: "space-between", md: "space-between", lg: "space-between" }}>
                                <Flex flexDirection={"column"}>
                                    <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                        <HStack spacing={1} align="center">
                                            <Checkbox
                                                isChecked={checkboxesState.includes(pedido.id)}
                                                my={2}
                                                mx={1}
                                                onChange={() => handleCheckboxChange(pedido.id)}
                                                id={`checkbox-${pedido.id}`}
                                                size={isMobile ? "lg" : "md"}
                                            />
                                            <VStack spacing={0} align="start">
                                                <Flex align="center">
                                                    <Link
                                                        href={(pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops") ? `https://www.mercadolivre.com.br/vendas/${pedido.id}/detalhe?` : null}
                                                        isExternal={(pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops")}
                                                    >
                                                        <Text mr={1} fontSize={{ base: "12px", md: "12px", lg: "14px" }}>
                                                            #{pedido.origem === "TAGA" ? pedido.id_taga : pedido.id}
                                                        </Text>
                                                    </Link>
                                                    <Box
                                                        color={"#595959"}
                                                        style={{ cursor: 'pointer' }}
                                                        id={"copy_pedido_" + (pedido.origem === "TAGA" ? pedido.id_taga : pedido.id)}
                                                        onClick={() => handleClickCopyPedido(pedido.origem === "TAGA" ? pedido.id_taga : pedido.id)}
                                                    >
                                                        <FaCopy size="0.8rem" />
                                                    </Box>
                                                </Flex>
                                                {pedido.pack_id && (
                                                    <Text
                                                        color="blue.600"
                                                        fontSize="11px"
                                                        fontWeight="bold"
                                                        lineHeight="1.1"
                                                    >
                                                        {`${isMobile ? '' : 'Pack: '}#${pedido.pack_id}`}
                                                    </Text>
                                                )}
                                            </VStack>
                                        </HStack>

                                        {
                                            isMobile && (
                                                <>
                                                    <Flex ml={{ base: "3", md: "0", lg: "0" }} flexDirection={"column"} align={"center"} justify={"center"}>
                                                        <Box>
                                                            <Text fontSize={{ base: "10px" }} align={"center"} fontWeight="bold">{pedido.data_hora}</Text>
                                                        </Box>
                                                        <Box>
                                                            <Text
                                                                display="flex"
                                                                whiteSpace="nowrap"
                                                                flexDirection={"row"}
                                                                alignItems="center"
                                                                h={"20px"}
                                                                align={"center"}
                                                                mr={0}
                                                                py={3}
                                                                px={1}
                                                                fontSize={{ base: "10px", md: "10px", lg: "12px" }}
                                                                bg={getBgBasedOnStatus(pedido.status)}
                                                                color={getColorBasedOnBg(getBgBasedOnStatus(pedido.status))}
                                                                borderRadius="lg"
                                                                fontWeight="bold"
                                                                border="1px solid black"
                                                            >
                                                                {getIconPedidoStatus(pedido.status)}
                                                                {pedido.status}
                                                            </Text>
                                                        </Box>
                                                    </Flex>
                                                </>
                                            )
                                        }
                                    </Flex>

                                    {
                                        isMobile && pedido.vendedor &&
                                        (
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Vendedor">
                                                <Flex flexDirection={"row"} justify={"start"} align={"center"}>
                                                    <Box ml={2} borderRadius={"full"} bg="yellow.300" px={1} border="1px solid black">
                                                        <Flex flexDirection={"row"} justify={"center"} align={"center"}>
                                                            <AiFillDollarCircle />
                                                            <Text ml={1} align={"center"} fontSize={"10px"} fontWeight={"bold"}>{pedido.vendedor.name}</Text>
                                                        </Flex>
                                                    </Box>
                                                </Flex>
                                            </TooltipSePuder>
                                        )
                                    }
                                </Flex>
                                {
                                    isMobile && pedido.flex == 1 && (
                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Pedido com Envio Flex">
                                            <Box my={2} mr={0} w={{ base: "25px", md: "40px", lg: "30px" }} >
                                                <Image loading="lazy" decoding="async" src="/logo_flex_ml.webp" alt="Logo Flex Mercado Livre" w={"100%"} h={{ base: "25px", md: "25px" }} borderRadius="full" />
                                            </Box>
                                        </TooltipSePuder>
                                    )
                                }
                                {
                                    pedido.origem == "Mercado Livre" &&
                                    (
                                        <Flex flexDirection={"row"} alignItems="center">
                                            <Box
                                                m={0}
                                                p={0}
                                                position="relative"
                                                ml={2}
                                                mr={{ base: "2", md: "2", lg: "2" }}
                                            >
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Marketplace">
                                                    <Box w={{ base: "70px", md: "70px", lg: "75px" }} >
                                                        <Image
                                                            loading="lazy" decoding="async"
                                                            src="/ml_logo_2.webp"
                                                            alt="Logo Mercado Livre"
                                                            w={"100%"}
                                                            h={{ base: "30px", md: "25px" }}
                                                            borderRadius="full"
                                                            border="1px solid black"
                                                        />
                                                    </Box>
                                                </TooltipSePuder>
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy
                                                    label={CONTAS_ML[pedido.conta] || CONTAS_ML[2]}
                                                >
                                                    <Box
                                                        position="absolute"
                                                        top="-5px"
                                                        left="-6px"
                                                        w="16px"
                                                        h="16px"
                                                        bg={pedido.conta === 1 ? "yellow.200" : pedido.conta === 3 ? "green.200" : "blue.200"}
                                                        borderRadius="full"
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        zIndex="1"
                                                        border="1px solid black"
                                                        boxShadow={"md"}
                                                    >
                                                        <Text fontWeight="bold" fontSize="14px" color="black">
                                                            {pedido.conta}
                                                        </Text>
                                                    </Box>
                                                </TooltipSePuder>
                                            </Box>
                                        </Flex>
                                    )
                                }
                                {
                                    pedido.origem == "Mercado Shops" &&
                                    (
                                        <Flex flexDirection={"row"} alignItems="center">
                                            <Box
                                                position="relative"
                                                ml={2}
                                                mr={{ base: "2", md: "2", lg: "2" }}
                                            >
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Mercado Shops">
                                                    <Box w={{ base: "70px", md: "70px", lg: "75px" }} >
                                                        <Image
                                                            loading="lazy" decoding="async"
                                                            src="/ms_logo.webp"
                                                            alt="Logo Mercado Shops"
                                                            w={"100%"}
                                                            h={{ base: "30px", md: "25px" }}
                                                            borderRadius="full"
                                                            border="1px solid black"
                                                        />
                                                    </Box>
                                                </TooltipSePuder>
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy
                                                    label={CONTAS_ML[pedido.conta] || CONTAS_ML[2]}
                                                >
                                                    <Box
                                                        position="absolute"
                                                        top="-5px"
                                                        left="-6px"
                                                        w="16px"
                                                        h="16px"
                                                        bg={pedido.conta === 1 ? "yellow.200" : pedido.conta === 3 ? "green.200" : "blue.200"}
                                                        borderRadius="full"
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        zIndex="1"
                                                        border="1px solid black"
                                                        boxShadow={"md"}
                                                    >
                                                        <Text fontWeight="bold" fontSize="11px" color="black">
                                                            {pedido.conta}
                                                        </Text>
                                                    </Box>
                                                </TooltipSePuder>
                                            </Box>
                                        </Flex>
                                    )
                                }
                                {
                                    !isMobile && pedido.flex == 1 && (
                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Pedido com Envio Flex">
                                            <Box my={2} mr={{ base: "1", md: "1", lg: "1" }} w={{ base: "40px", md: "40px", lg: "30px" }} >
                                                <Image loading="lazy" decoding="async" src="/logo_flex_ml.webp" alt="Logo Flex Mercado Livre" w={"100%"} h={{ base: "25px", md: "25px" }} borderRadius="full" />
                                            </Box>
                                        </TooltipSePuder>
                                    )
                                }
                                {
                                    pedido.origem == "Magalu" &&
                                    (
                                        <Flex flexDirection={"row"}>
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Marketplace">
                                                <Box m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "90px", md: "70px", lg: "75px" }}>
                                                    <Image loading="lazy" decoding="async" src="/magalu-logo.webp" alt="Logo Magalu" w={"100%"} h={{ base: "40px", md: "25px" }} borderRadius="full" />
                                                </Box>
                                            </TooltipSePuder>
                                        </Flex>
                                    )
                                }
                                {
                                    pedido.origem == "Amazon" &&
                                    (
                                        <Flex flexDirection={"row"}>
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Marketplace">
                                                <Box h={{ base: "40px", md: "25px" }} align="center" bg='white' m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "90px", md: "70px", lg: "75px" }} borderRadius="full">
                                                    <Flex justify={"center"} align={"center"}>
                                                        <Image loading="lazy" decoding="async" mt={{ base: "3", md: "1", lg: "1" }} src="/amazon-logo.webp" alt="Logo Magalu" w={"80%"} />
                                                    </Flex>
                                                </Box>
                                            </TooltipSePuder>
                                        </Flex>
                                    )
                                }
                                {
                                    pedido.origem == "TAGA" &&
                                    (
                                        <Flex flexDirection={"row"}>
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Venda Manual">
                                                <Box
                                                    h={{ base: "25px", md: "25px" }}
                                                    align="center"
                                                    bg="black"
                                                    m={2}
                                                    mr={{ base: "2", md: "2", lg: "4" }}
                                                    w={{ base: "50px", md: "50px", lg: "50px" }}
                                                    borderRadius="full"
                                                >
                                                    <Flex justify={"center"} align={"center"} h="100%" w="99%" py={0.5}>
                                                        <Image
                                                            loading="lazy" decoding="async"
                                                            src="/taga_logo.jpg"
                                                            alt="Logo TAGA"
                                                            w="100%"
                                                            h="100%"
                                                            objectFit="contain"
                                                        />
                                                    </Flex>
                                                </Box>
                                            </TooltipSePuder>
                                        </Flex>

                                    )
                                }
                                {
                                    pedido.origem == "ECOMMERCE" &&
                                    (
                                        <Flex flexDirection={"row"}>
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Venda ECOMMERCE">
                                                <Box
                                                    h={{ base: "25px", md: "25px" }}
                                                    align="center"
                                                    bg="black"
                                                    m={2}
                                                    mr={{ base: "2", md: "2", lg: "4" }}
                                                    w={{ base: "50px", md: "50px", lg: "50px" }}
                                                    borderRadius="full"
                                                >
                                                    <Flex justify={"center"} align={"center"} h="100%" w="99%" py={0.5}>
                                                        <Image
                                                            loading="lazy" decoding="async"
                                                            src="/taga_logo.jpg"
                                                            alt="Logo TAGA"
                                                            w="100%"
                                                            h="100%"
                                                            objectFit="contain"
                                                        />
                                                    </Flex>
                                                </Box>
                                            </TooltipSePuder>
                                        </Flex>

                                    )
                                }
                                {
                                    false && checkPermission() && (
                                        !isMobile && (loadingMini === true && checkboxesState.includes(pedido.id) ? (<PreloaderMini />) : (
                                            pedido.cotada === 1 ? (
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Venda cotada. Clique para alterar o status.">
                                                    <Button
                                                        m={0}
                                                        p={0}
                                                        _hover={{ color: "white", transition: "color 1s" }}
                                                        color={"#01695E"}
                                                        id={'pedido_status_cotacao_' + pedido.id}
                                                        background={"none"}
                                                        _active={"none"} _focus={"none"}
                                                        leftIcon={<FaCartArrowDown className="custom-hover" fontSize="1.2rem" />}
                                                        onClick={() => handleCotacaoVenda(pedido.id, 0)}
                                                    >
                                                    </Button>
                                                </TooltipSePuder>
                                            ) : (
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Venda não cotada. Clique para alterar o status." >
                                                    <Button
                                                        m={0}
                                                        p={0}
                                                        _hover={{ color: "white", transition: "color 1s" }}
                                                        color={"red"}
                                                        background={"none"}
                                                        _active={"none"} _focus={"none"}
                                                        id={'pedido_status_cotacao_' + pedido.id}
                                                        leftIcon={<FaCartArrowDown className="custom-hover" fontSize="1.2rem" />}
                                                        onClick={() => handleCotacaoVenda(pedido.id, 1)}
                                                    >
                                                    </Button>
                                                </TooltipSePuder>
                                            )
                                        ))
                                    )
                                }
                                {
                                    !isMobile && pedido.vendedor &&
                                    (
                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Vendedor">
                                            <Flex flexDirection={"row"} justify={"center"} align={"center"}>
                                                <Box borderRadius={"full"} bg="yellow.300" px={1} border="1px solid black">
                                                    <Flex flexDirection={"row"} justify={"center"} align={"center"}>
                                                        <AiFillDollarCircle />
                                                        <Text ml={1} align={"center"} fontSize={"12px"} fontWeight={"bold"}>{pedido.vendedor.name}</Text>
                                                    </Flex>
                                                </Box>
                                            </Flex>
                                        </TooltipSePuder>
                                    )
                                }
                            </Flex>
                            {
                                isMobile &&
                                (
                                    <Divider style={{ borderColor: 'black' }} my="1" />
                                )
                            }
                            <Flex align={"center"} justify={{ base: "space-between", md: "space-between", lg: "space-between" }}>
                                {
                                    false && !isMobile && (
                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Comprador">
                                            <Flex flexDirection={"row"} mr={1}>
                                                <Text my={2} fontSize={{ base: "10px", md: "10px", lg: "12px" }}>({limitarCaracteres(pedido?.comprador?.nickname, 30)})</Text>
                                            </Flex>
                                        </TooltipSePuder>
                                    )
                                }
                                {
                                    !isMobile &&
                                    (
                                        <Text
                                            m={2}
                                            fontSize={{ base: "10px", md: "10px", lg: "12px" }}
                                            fontWeight="bold"
                                            whiteSpace="nowrap"
                                        >
                                            {pedido.data_hora}
                                        </Text>
                                    )
                                }
                                {
                                    !isMobile &&
                                    (
                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Status Marketplace">
                                            <Text
                                                display="flex"
                                                whiteSpace="nowrap"
                                                flexDirection={"row"}
                                                alignItems="center"
                                                h={"25px"}
                                                align={"center"}
                                                ml={{ base: "2", md: "0", lg: "0" }}
                                                my={2}
                                                mr={0}
                                                fontSize={{ base: "10px", md: "10px", lg: "12px" }}
                                                bg={getBgBasedOnStatus(pedido.status)}
                                                p={1}
                                                color={getColorBasedOnBg(getBgBasedOnStatus(pedido.status))}
                                                borderRadius="lg"
                                                fontWeight="bold"
                                                border="1px solid black"
                                            >
                                                {getIconPedidoStatus(pedido.status)} {/* Ícone */}
                                                {pedido.status} {/* Texto */}
                                            </Text>
                                        </TooltipSePuder>
                                    )
                                }
                                <Flex w="100%" justify={"flex-end"} alignItems="center" mr={2}>
                                    {
                                        checkPermission() && isMobile &&
                                        (
                                            <MarcadoresVenda onOptionClick={handleMarcadorTaga} idVenda={pedido.id_taga} marcadorAtual={pedido.marcador} />
                                        )
                                    }
                                    {
                                        isMobile &&
                                        (
                                            <Notas handleAddObs={handleAddObs} idVenda={pedido.id_taga} handleChangeTextObs={handleChangeTextObs} textObs={textObs} observacoes={pedido.observacoes} handleApagarObs={handleApagarObs} />
                                        )
                                    }
                                    {
                                        checkPermission() && isMobile &&
                                        (
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Visualizar Pedido">
                                                <Box
                                                    bg="gray.300"
                                                    w="45px"
                                                    h="45px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    borderRadius="full"
                                                    mr={4}
                                                    _hover={{ color: "white", transition: "color 1s" }}
                                                    color={"black"}
                                                    _active={"none"} _focus={"none"}
                                                    onClick={
                                                        (pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops")
                                                            ? () => openModalViewPedido(pedido.id)
                                                            : (pedido.origem === "TAGA" || pedido.origem === "ECOMMERCE")
                                                                ? () => openModalViewPedidoTaga(pedido.id_taga)
                                                                : () => { }
                                                    }
                                                >
                                                    <FaEye style={{ width: '20px', height: '20px' }} />
                                                </Box>
                                            </TooltipSePuder>
                                        )
                                    }
                                    {
                                        checkPermission() && (
                                            isMobile && (pedido.origem == "Mercado Livre" || pedido.origem == "Mercado Shops") &&
                                            (
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label={msgTooltipLabel}>
                                                    <Box position="relative" mr={4}>
                                                        <Box
                                                            bg={msgBotaoBg}
                                                            w="45px"
                                                            h="45px"
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            borderRadius="full"
                                                            _hover={{ color: "white", transition: "color 1s" }}
                                                            color={"black"}
                                                            _active={"none"} _focus={"none"}
                                                            onClick={() => consultarMensagensVendas(pedido.id)}
                                                        >
                                                            <IoMdChatboxes style={{ width: '20px', height: '20px' }} />
                                                        </Box>
                                                        {naoLidasPorPackId[String(pedido.pack_id)]?.nao_lida && (
                                                            <Badge
                                                                position="absolute"
                                                                top="-2px"
                                                                right="-2px"
                                                                colorScheme="red"
                                                                borderRadius="full"
                                                                minW="16px"
                                                                h="16px"
                                                                fontSize="10px"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                px={1}
                                                            >
                                                                {naoLidasPorPackId[String(pedido.pack_id)]?.qtd > 0
                                                                    ? naoLidasPorPackId[String(pedido.pack_id)].qtd
                                                                    : '•'}
                                                            </Badge>
                                                        )}
                                                    </Box>
                                                </TooltipSePuder>
                                            )
                                        )
                                    }
                                    {
                                        checkPermission() && (
                                            !isMobile && (pedido.origem == "Mercado Livre" || pedido.origem == "Mercado Shops") && (
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label={msgTooltipLabel}>
                                                    <Box position="relative" ml={1}>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            bg={msgBotaoBg}
                                                            borderRadius="full"
                                                            width="30px"
                                                            height="30px"
                                                            cursor="pointer"
                                                            _hover={{ bg: "white", transition: "color 0.3s" }}
                                                            onClick={() => consultarMensagensVendas(pedido.id)}
                                                            border="1px solid black"
                                                        >
                                                            <IoMdChatboxes fontSize='20px' />
                                                        </Box>
                                                        {naoLidasPorPackId[String(pedido.pack_id)]?.nao_lida && (
                                                            <Badge
                                                                position="absolute"
                                                                top="-3px"
                                                                right="-3px"
                                                                colorScheme="red"
                                                                borderRadius="full"
                                                                minW="14px"
                                                                h="14px"
                                                                fontSize="9px"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                px={0}
                                                            >
                                                                {naoLidasPorPackId[String(pedido.pack_id)]?.qtd > 0
                                                                    ? naoLidasPorPackId[String(pedido.pack_id)].qtd
                                                                    : '•'}
                                                            </Badge>
                                                        )}
                                                    </Box>
                                                </TooltipSePuder>
                                            )
                                        )
                                    }
                                    {
                                        checkPermission() && !isMobile &&
                                        (
                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Visualizar Pedido">
                                                <Box
                                                    mx={1}
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    bg="#eb9659"
                                                    borderRadius="full"
                                                    width="30px"
                                                    height="30px"
                                                    cursor="pointer"
                                                    _hover={{ bg: "white", transition: "color 0.3s" }}
                                                    onClick={
                                                        (pedido.origem === "Mercado Livre" || pedido.origem === "Mercado Shops")
                                                            ? () => openModalViewPedido(pedido.id)
                                                            : (pedido.origem === "TAGA" || pedido.origem === "ECOMMERCE")
                                                                ? () => openModalViewPedidoTaga(pedido.id_taga)
                                                                : () => { }
                                                    }
                                                    border="1px solid black"
                                                >
                                                    <FaEye style={{ width: '20px', height: '20px' }} />
                                                </Box>
                                            </TooltipSePuder>
                                        )


                                    }

                                    <Box position="relative">

                                        {/* BOTÃO DE AÇÕES */}
                                        {checkPermission() && (
                                            /* REF DO BOTÃO: Fica Apenas NESTA div wrapper */
                                            <div ref={buttonRef} id="button_acao_massa">
                                                <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label="Ações">
                                                    <Box
                                                        bg="#eb9659"
                                                        p={isMobile ? "4" : "2"}
                                                        borderRadius="full"
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        _hover={{ background: "white" }}
                                                        color={"black"}
                                                        _focus={{ color: "white" }}
                                                        onClick={() => toggleMenu(pedido.id)}
                                                        cursor={"pointer"}
                                                        border="1px solid black"
                                                    >
                                                        <FaEllipsisV className="acoes_button" style={{ width: '15px', height: '15px' }} />
                                                    </Box>
                                                </TooltipSePuder>
                                            </div>
                                        )}

                                        {/* MENU DROPDOWN */}
                                        {menuVisivel == pedido.id && (
                                            <Box
                                                ref={listaRef} /* REF DA LISTA: Fica direto no container absolute */
                                                position="absolute"
                                                /* Lógica: Se for o último, abre para CIMA. Senão, para BAIXO. */
                                                top={isLastItem ? "auto" : "100%"}
                                                bottom={isLastItem ? "100%" : "auto"}
                                                right={0}
                                                zIndex={99999}
                                                bg="white"
                                                mt={isLastItem ? 0 : 2}
                                                mb={isLastItem ? 2 : 0}
                                                border="1px solid #ccc"
                                                borderRadius="4px"
                                                minWidth="280px"
                                                boxShadow="0 4px 12px rgba(0,0,0,0.2)"
                                                maxHeight="300px"
                                                overflowY="auto"
                                            >
                                                <Box as="ul" fontSize={"14px"} listStyleType="none" m={0} p={0} textAlign="left">
                                                    {/* ... SEU CONTEÚDO DA LISTA (MANTENHA IGUAL) ... */}
                                                    <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Cotação </Text>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "lista_cotacao")} >Gerar lista</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_cotacao_sim")} >Marcar Cotada(s)</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_cotacao_nao")} >Desmarcar Cotada(s)</li>

                                                    <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Furo de Estoque </Text>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_furo_estoque_sim")} >Marcar Furo de Estoque</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_furo_estoque_nao")} >Desmarcar Furo de Estoque</li>

                                                    <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Status VENDA </Text>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_1")}> CONFIRMADA</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_2")}> PARA ENVIAR</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_3")}> EM TRÂNSITO</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_4")}> CONCLUÍDA</li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id_taga, "status_venda_5")}> CANCELADA</li>

                                                    <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Status TAGA </Text>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_sim")} ><p style={{ fontWeight: "bold", color: "#1ab000", ...estiloPadraoP }}>CONFIRMADA</p></li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_nao")} ><p style={{ fontWeight: "bold", color: "red", ...estiloPadraoP }}>CANCELADA</p></li>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => handleChangeAcaoIndiv(pedido.id, "set_status_taga_pen")} ><p style={{ fontWeight: "bold", color: "#c7c106", ...estiloPadraoP }}>PENDENTE</p></li>

                                                    {isEntregaCombinar && (
                                                        <>
                                                            <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Entrega a Combinar </Text>
                                                            <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => { toggleMenu(null); handleOpenEntregaModal(); }}><p style={{ fontWeight: "bold", color: "#c2410c", ...estiloPadraoP }}>Confirmar Dados de Entrega</p></li>
                                                        </>
                                                    )}

                                                    <Text bg="#ababab" px={2} py={1} fontSize={"14px"} fontWeight={"bold"}> Ticket </Text>
                                                    <li className='list-options' style={{ padding: '8px 12px', cursor: 'pointer' }} onClick={() => openTicketModal(pedido)}>Criar Ticket de Problema</li>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                </Flex>
                            </Flex>
                            {
                                isMobile && (
                                    <Divider mb={0} pb={0} style={{ borderColor: 'black' }} mt={{ base: "2", md: "2", lg: "0" }} />
                                )
                            }
                        </Flex>
                        {
                            !isMobile && (
                                <Divider mb={0} pb={0} style={{ borderColor: 'black' }} mt={{ base: "2", md: "2", lg: "0" }} />
                            )
                        }
                        <Flex justifyContent={"center"} m={0} p={0}>
                            {
                                !isMobile && pedido.marcador > 0 && (
                                    <Flex px={2} mt={1} borderRadius="lg" color="black" bg="white" flexDirection={"row"} justify={"center"} align={"center"}>
                                        {getIconMarcador(pedido)}
                                        <Text ml={2} fontWeight="extrabold" fontSize={{ base: "10px", md: "10px", lg: "12px" }}>{getTextoMarcador(pedido)}</Text>
                                    </Flex>
                                )
                            }
                        </Flex>
                        <Flex ml={1} mb={1} flexDirection={"row"} align={"center"} justify={"center"}>
                            {
                                isMobile && pedido.marcador > 0 && (
                                    <Flex px={2} borderRadius="lg" color="black" bg="white" flexDirection={"row"} justify={"center"} align={"center"}>
                                        {getIconMarcador(pedido)}
                                        <Text ml={2} fontWeight="extrabold" fontSize={{ base: "10px", md: "10px", lg: "12px" }}>{getTextoMarcador(pedido)}</Text>
                                    </Flex>
                                )
                            }
                        </Flex>

                        {/* <Flex flexDirection={"row"} justify={"space-between"} mx={4}>
                                                <Text fontWeight={"bold"} fontSize={{ base: "10px", md: "10px", lg: "16px" }}>{pedido.total_itens}{pedido.produtos.length > 1 ? " itens" : " item"}</Text>
                                                {<Text fontWeight={"bold"} fontSize={{ base: "10px", md: "10px", lg: "16px" }}>Total: R${pedido.total}</Text> }
                                            </Flex> */}
                        {pedido.extrato && (pedido.extrato.cancelados > 0 || pedido.extrato.devolvidos > 0) && pedido.extrato.cancelados + pedido.extrato.devolvidos < pedido.extrato.valor_bruto && (
                            <Flex gap={1} px={2} pt={1} wrap="wrap">
                                {pedido.extrato.cancelados > 0 && <Badge colorScheme="red" fontSize="10px">Item cancelado</Badge>}
                                {pedido.extrato.devolvidos > 0 && <Badge colorScheme="purple" fontSize="10px">Devolução parcial</Badge>}
                            </Flex>
                        )}
                        <TableContainer width={"100%"} m={0} p={0}>
                            <Table size='sm' m={0} p={0}>
                                <Thead width={"100%"}>
                                    <Tr>
                                        <Th px={1} w={"30%"}><Text align='center'>PRODUTO</Text></Th>
                                        <Th px={1} w={"20%"}>
                                            <Flex align='center' justify='center' gap={1}>
                                                <Text>CLIENTE</Text>
                                                <TooltipSePuder desativado={isMobile} label="Editar cliente" openDelay={400}>
                                                    <IconButton
                                                        icon={<MdEdit />}
                                                        size="xs"
                                                        variant="ghost"
                                                        colorScheme="orange"
                                                        minW="18px"
                                                        h="18px"
                                                        border="1.5px solid black"
                                                        borderRadius="sm"
                                                        onClick={handleOpenClienteModal}
                                                        aria-label="Editar cliente"
                                                    />
                                                </TooltipSePuder>
                                            </Flex>
                                        </Th>
                                        <Th px={1} w={"15%"}><Text align='center'>FISCAL</Text></Th>
                                        <Th px={1} w={"12%"}><Text align='center'>ENVIO</Text></Th>
                                        <Th px={1} w={"13%"}><Text align='center'>QUANTIDADE</Text></Th>
                                        <Th px={1} w={"10%"}><Text align='center'>PREÇO</Text></Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {pedido.produtos.map((produto, index) => (
                                        <Tr key={produto.id} width={"100%"}>
                                            <Td pl={1}>
                                                <Flex align="start" bg="rgba(0, 0, 0, 0.06)" borderRadius="lg" p={1} position="relative">
                                                    <IconButton
                                                        aria-label="Mostrar mais detalhes"
                                                        variant="ghost"
                                                        size="xs" // Alterado de "sm" para "xs"
                                                        onClick={() => handleToggleProductDetails(pedido.id, produto.id)}
                                                        icon={
                                                            isProductExpanded(pedido.id, produto.id) ? (
                                                                <ChevronUpIcon />
                                                            ) : (
                                                                <ChevronDownIcon />
                                                            )
                                                        }
                                                        position="absolute"
                                                        top="4px"
                                                        right="4px"
                                                        zIndex="1"
                                                    />
                                                    <Box mr={2}>
                                                        <Flex flexDirection={"column"}>
                                                            <ListaCompraStatusBadge
                                                                listaCompraStatus={resolverListaStatus(produto)}
                                                                onClickSemLista={(info) => handleOpenListaModal(produto, info?.status)}
                                                            />
                                                            <ProdutoImagem
                                                                produto={produto}
                                                                origem={pedido.origem}
                                                                width={"70px"}
                                                                height={"70px"}
                                                            />
                                                            {!itemForaDoPedido(produto) && <StatusConferenciaBadge
                                                                status={produto.conferencia_status}
                                                                vendaId={pedido.id_taga}
                                                                produtoEstoqueId={produto.id}
                                                            />}
                                                        </Flex>
                                                    </Box>
                                                    <Flex ml={0} flex="1" fontSize="10px" flexDirection="column">
                                                        <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label={produto.nome}>
                                                            <Text fontSize="10px" fontWeight="bold" noOfLines={1} maxW="90%">
                                                                {limitarCaracteres(produto.nome, 30)}
                                                            </Text>
                                                        </TooltipSePuder>
                                                        {Number(produto.furo_estoque) === 1 && (
                                                            <Badge colorScheme="red" fontSize="9px" alignSelf="flex-start" mb="2px">
                                                                FURO DE ESTOQUE
                                                            </Badge>
                                                        )}
                                                        {Number(produto.furo_estoque) !== 1 && Number(produto.furo_estoque_coberto) === 1 && (
                                                            <Badge colorScheme="green" fontSize="9px" alignSelf="flex-start" mb="2px">
                                                                FURO COBERTO
                                                            </Badge>
                                                        )}
                                                        <SelosOcorrenciasItem pedido={pedido} produto={produto} acoes={acoesItem} podeAgir={checkPermission()} desativarDica={isMobile} />
                                                        <Flex flexDirection="row">
                                                            <Text mr={1} color="#525F65" fontWeight="bold">SKU:</Text>
                                                            <Text mr={1}>{produto.id}</Text>
                                                            <Link mt="0.5" href={`${window.location.origin}/produtos?id=${produto.id}`} isExternal>
                                                                <FaExternalLinkAlt size={12} color="blue" />
                                                            </Link>
                                                        </Flex>
                                                        <Flex flexDirection="row">
                                                            <Text mr={1} color="#525F65" fontWeight="bold">Código Global:</Text>
                                                            <Text fontWeight="bold">{(produto.codigo != null && produto.codigo.length > 0) ? produto.codigo : " - "}</Text>
                                                        </Flex>
                                                        <Flex flexDirection="row">
                                                            <Text mr={1} color="#525F65" fontWeight="bold">Fabricante:</Text>
                                                            <Text>{(produto.fabricante != null && produto.fabricante.length > 0) ? produto.fabricante : " - "}</Text>
                                                        </Flex>
                                                        <Flex flexDirection="row">
                                                            <Text mr={1} color="#525F65" fontWeight="bold">Fornecedor:</Text>
                                                            <TooltipSePuder desativado={isMobile} openDelay={500} isLazy label={produto.fornecedor}>
                                                                <Flex justify="center" align="center">
                                                                    <Box w={{ base: "100%", md: "100%", lg: "50%" }}>
                                                                        <Flex justifyContent={"center"}>
                                                                            <Image
                                                                                loading="lazy" decoding="async"
                                                                                borderRadius="lg"
                                                                                src={getImagemFornecedor(produto.fornecedor)}
                                                                                alt={produto.fornecedor}
                                                                                h="34px"
                                                                                w="auto"
                                                                                maxW="90px"
                                                                                objectFit="contain"
                                                                            />
                                                                        </Flex>
                                                                    </Box>
                                                                </Flex>
                                                            </TooltipSePuder>
                                                        </Flex>
                                                        <Collapse in={isProductExpanded(pedido.id, produto.id)} animateOpacity>
                                                            <Flex flexDirection="column">
                                                                <Flex flexDirection="row">
                                                                    <Text mr={2} color="#525F65" fontWeight="bold">Código Fabricante:</Text>
                                                                    <Text>{(produto.codigo_fabricante != null && produto.codigo_fabricante.length > 0) ? produto.codigo_fabricante : " - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection="row">
                                                                    <Text mr={2} color="#525F65" fontWeight="bold">Código Fornecedor:</Text>
                                                                    <Text>{(produto.codigo_fornecedor != null && produto.codigo_fornecedor.length > 0) ? produto.codigo_fornecedor : " - "}</Text>
                                                                </Flex>
                                                                <Flex flexDirection="row">
                                                                    <Text mr={2} color="#525F65" fontWeight="bold">ID Anúncio:</Text>
                                                                    <Text>{produto.id_ml}</Text>
                                                                    <Box color="#595959" mx={1} p={0} style={{ cursor: 'pointer' }} id={`copy_anuncio_${produto.id_ml}`} onClick={() => handleClickCopyAnuncio(produto.id_ml)}>
                                                                        <FaCopy fontSize="0.8rem" />
                                                                    </Box>
                                                                </Flex>
                                                            </Flex>
                                                        </Collapse>
                                                    </Flex>
                                                </Flex>
                                            </Td>
                                            {index === 0 && (
                                                <>
                                                    <Td>
                                                        <Flex flexDirection={"column"} fontSize={"10px"} bg="rgba(0, 0, 0, 0.06)" borderRadius="lg" p={1}>
                                                            {
                                                                clienteAtual?.nickname?.length > 0 &&
                                                                (
                                                                    <Flex flexDirection={"row"}>
                                                                        <Text mr={1} color="#525F65" fontWeight="bold">Nickname:</Text>
                                                                        <Text
                                                                            textAlign='center'
                                                                            maxWidth="120px"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >{clienteAtual?.nickname}</Text>
                                                                    </Flex>
                                                                )
                                                            }
                                                            {
                                                                clienteAtual?.nome?.length > 0 &&
                                                                (
                                                                    <Flex flexDirection={"row"}>
                                                                        <Text mr={1} color="#525F65" fontWeight="bold">Nome:</Text>
                                                                        <Text
                                                                            textAlign='center'
                                                                            maxWidth="120px"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >{clienteAtual?.nome}</Text>
                                                                    </Flex>
                                                                )
                                                            }
                                                            {
                                                                clienteAtual?.telefone?.length > 0 &&
                                                                (
                                                                    <Flex flexDirection={"row"}>
                                                                        <Text mr={1} color="#525F65" fontWeight="bold">Tel:</Text>
                                                                        <Text
                                                                            textAlign='center'
                                                                            maxWidth="120px"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >{clienteAtual?.telefone}</Text>
                                                                    </Flex>
                                                                )
                                                            }
                                                            {
                                                                clienteAtual?.email?.length > 0 &&
                                                                (
                                                                    <Flex flexDirection={"row"}>
                                                                        <Text mr={1} color="#525F65" fontWeight="bold">Email:</Text>
                                                                        <Text
                                                                            textAlign='center'
                                                                            maxWidth="120px"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >{clienteAtual?.email}</Text>
                                                                    </Flex>
                                                                )
                                                            }
                                                            {
                                                                clienteAtual?.documento?.length > 0 &&
                                                                (
                                                                    <Flex flexDirection={"row"}>
                                                                        <Text mr={1} color="#525F65" fontWeight="bold">Doc:</Text>
                                                                        <Text
                                                                            textAlign='center'
                                                                            maxWidth="120px"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >{clienteAtual?.documento}</Text>
                                                                    </Flex>
                                                                )
                                                            }
                                                            {!clienteAtual && (
                                                                <Text color="gray.400" fontStyle="italic" pr="20px">Sem dados</Text>
                                                            )}
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        {
                                                            (pedido.origem == "Mercado Livre" || pedido.origem == "Mercado Shops") && pedido.notaEmitida == true && (
                                                                <>
                                                                    <Flex flexDirection="row" justify="center" align="center">
                                                                        <Text fontWeight="bold"
                                                                            fontSize="10px"
                                                                            textTransform="uppercase"
                                                                        >✅Nota Emitida</Text>
                                                                    </Flex>
                                                                    <Flex hidden flexDirection="row" justify="center" align="center">
                                                                        <Box
                                                                            id={"imprimir_etiqueta_pdf_" + pedido.id_taga}
                                                                            bg="white"
                                                                            p="1"
                                                                            borderRadius="lg"
                                                                            mt={2}
                                                                            cursor="pointer"
                                                                            transition="all 0.2s"
                                                                            color="blue"
                                                                            _hover={{
                                                                                transform: "scale(1.05)",
                                                                                bg: "blue",
                                                                                color: "white",
                                                                            }}
                                                                        >
                                                                            <Flex flexDirection={"row"}>
                                                                                <FaDownload />
                                                                                <Text
                                                                                    ml={1}
                                                                                    fontWeight="bold"
                                                                                    fontSize="10px"
                                                                                >
                                                                                    XML
                                                                                </Text>
                                                                            </Flex>
                                                                        </Box>
                                                                    </Flex>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            (pedido.origem == "TAGA") && pedido.notaEmitida == true && (
                                                                <>
                                                                    <Flex flexDirection="row" justify="center" align="center">
                                                                        <Text fontWeight="bold"
                                                                            fontSize="10px"
                                                                            textTransform="uppercase"
                                                                        >✅Nota Emitida</Text>
                                                                    </Flex>
                                                                    <Flex hidden flexDirection="row" justify="center" align="center">
                                                                        <Box
                                                                            id={"imprimir_etiqueta_pdf_" + pedido.id_taga}
                                                                            bg="white"
                                                                            p="1"
                                                                            borderRadius="lg"
                                                                            mt={2}
                                                                            cursor="pointer"
                                                                            transition="all 0.2s"
                                                                            color="blue"
                                                                            _hover={{
                                                                                transform: "scale(1.05)",
                                                                                bg: "blue",
                                                                                color: "white",
                                                                            }}
                                                                        >
                                                                            <Flex flexDirection={"row"}>
                                                                                <FaDownload />
                                                                                <Text
                                                                                    ml={1}
                                                                                    fontWeight="bold"
                                                                                    fontSize="10px"
                                                                                >
                                                                                    XML
                                                                                </Text>
                                                                            </Flex>
                                                                        </Box>
                                                                    </Flex>
                                                                </>
                                                            )
                                                        }
                                                        {
                                                            (pedido.origem == "Mercado Livre" || pedido.origem == "Mercado Shops") && pedido.notaEmitida == false && (
                                                                <>
                                                                    <Flex flexDirection="row" justify="center" align="center">
                                                                        <Text fontWeight="bold"
                                                                            fontSize="10px"
                                                                            textTransform="uppercase"
                                                                        >⚠️Nota Pendente</Text>
                                                                    </Flex>
                                                                    {

                                                                        <Flex flexDirection="row" justify="center" align="center">
                                                                            {
                                                                                loadingItemsNFML[pedido.id_taga] ? (
                                                                                    <Box mt={2}>
                                                                                        <Spinner size="md" />
                                                                                    </Box>
                                                                                ) : (

                                                                                    <Box
                                                                                        id={"imprimir_etiqueta_pdf_" + pedido.id_taga}
                                                                                        bg="yellow"
                                                                                        p="1"
                                                                                        borderRadius="lg"
                                                                                        mt={2}
                                                                                        cursor="pointer"
                                                                                        transition="all 0.2s"
                                                                                        color="black"
                                                                                        _hover={{
                                                                                            transform: "scale(1.05)",
                                                                                            bg: "black",
                                                                                            color: "yellow",
                                                                                        }}
                                                                                        onClick={() => openModalConfirmNF(pedido.id_taga, pedido.id)}
                                                                                    >
                                                                                        <Flex flexDirection={"row"}>
                                                                                            <FaFileInvoice />
                                                                                            <Text
                                                                                                ml={1}
                                                                                                fontWeight="bold"
                                                                                                fontSize="10px"
                                                                                            >
                                                                                                EMITIR
                                                                                            </Text>
                                                                                        </Flex>
                                                                                    </Box>
                                                                                )
                                                                            }
                                                                        </Flex>

                                                                    }
                                                                </>
                                                            )
                                                        }
                                                        {/* BLOCO PARA VENDAS MANUAIS (TAGA) */}
                                                        {(pedido.origem == "TAGA" || pedido.origem == "ECOMMERCE") && pedido.notaEmitida == false && (
                                                            <>
                                                                <Flex flexDirection="row" justify="center" align="center">
                                                                    <Text
                                                                        fontWeight="bold"
                                                                        fontSize="10px"
                                                                        textTransform="uppercase"
                                                                    >
                                                                        ⚠️Nota Pendente
                                                                    </Text>
                                                                </Flex>

                                                                <Flex flexDirection="row" justify="center" align="center">
                                                                    <Box
                                                                        id={"emitir_nfe_taga_" + pedido.id_taga}
                                                                        bg="yellow"
                                                                        p="1"
                                                                        borderRadius="lg"
                                                                        mt={2}
                                                                        cursor="pointer"
                                                                        transition="all 0.2s"
                                                                        color="black"
                                                                        _hover={{
                                                                            transform: "scale(1.05)",
                                                                            bg: "black",
                                                                            color: "yellow",
                                                                        }}
                                                                        onClick={() => openModalConfirmNfeTaga(pedido.id_taga)}
                                                                    >
                                                                        <Flex flexDirection={"row"}>
                                                                            <FaFileInvoice />
                                                                            <Text
                                                                                ml={1}
                                                                                fontWeight="bold"
                                                                                fontSize="12px"
                                                                            >
                                                                                EMITIR
                                                                            </Text>
                                                                        </Flex>
                                                                    </Box>
                                                                </Flex>
                                                            </>
                                                        )}
                                                    </Td>
                                                    <Td pl={0}>
                                                        <Flex px={0} mx={0} justify="center" align="center" flexDirection={"column"}>
                                                            {
                                                                pedido.envio && pedido.envio.modo_envio &&
                                                                (
                                                                    isEntregaCombinar ? (
                                                                        <TooltipSePuder desativado={isMobile} openDelay={300} isLazy label="Confirmar Dados de Entrega">
                                                                            <Text
                                                                                textDecoration="underline"
                                                                                color="red.400"
                                                                                fontSize={"10px"}
                                                                                textTransform="uppercase"
                                                                                fontWeight={"bold"}
                                                                                px={1} mx={0}
                                                                                align='center'
                                                                                cursor="pointer"
                                                                                onClick={handleOpenEntregaModal}
                                                                                transition="all 0.15s"
                                                                                _hover={{ color: "red.600", bg: "red.50", transform: "scale(1.05)" }}
                                                                            >{pedido.envio.modo_envio}</Text>
                                                                        </TooltipSePuder>
                                                                    ) : (
                                                                        <Text textDecoration="underline" color="blue.600" fontSize={"10px"} textTransform="uppercase" fontWeight={"bold"} px={0} mx={0} align='center'>{pedido.envio.modo_envio}</Text>
                                                                    )
                                                                )
                                                            }
                                                            {isColetaMl(pedido.envio) && (
                                                                <TooltipSePuder desativado={isMobile} openDelay={300} isLazy label="Coleta: a transportadora do Mercado Livre retira o pacote aqui na TAGA">
                                                                    <Badge
                                                                        colorScheme="pink"
                                                                        variant="solid"
                                                                        fontSize="8px"
                                                                        px={1.5}
                                                                        mt="3px"
                                                                        borderRadius="sm"
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        gap="3px"
                                                                    >
                                                                        <Box as={FaTruckLoading} fontSize="9px" flexShrink={0} />
                                                                        COLETA
                                                                    </Badge>
                                                                </TooltipSePuder>
                                                            )}
                                                            {/* Entrega a combinar so sai de "Combine a entrega" no ML — e so
                                                                libera o dinheiro — depois que avisamos a entrega. O selo mostra
                                                                que esse aviso ja foi dado, e o alerta mostra quando falhou. */}
                                                            {isEntregaCombinar && avisoEntregaMl && (
                                                                <TooltipSePuder
                                                                    desativado={isMobile}
                                                                    openDelay={300}
                                                                    isLazy
                                                                    label={avisoEntregaMl.descricao}
                                                                >
                                                                    <Flex
                                                                        align="center"
                                                                        justify="center"
                                                                        gap="3px"
                                                                        mt="3px"
                                                                        px={1.5}
                                                                        py="1px"
                                                                        maxW="100%"
                                                                        borderRadius="sm"
                                                                        bg={avisoEntregaMl.bg}
                                                                        border="1px solid"
                                                                        borderColor={avisoEntregaMl.borda}
                                                                        cursor="default"
                                                                    >
                                                                        <Box as={avisoEntregaMl.icone} color={avisoEntregaMl.cor} fontSize="9px" flexShrink={0} />
                                                                        <Text
                                                                            fontSize="8px"
                                                                            fontWeight="bold"
                                                                            color={avisoEntregaMl.cor}
                                                                            lineHeight="1.4"
                                                                            textAlign="center"
                                                                            whiteSpace="normal"
                                                                            overflowWrap="break-word"
                                                                        >
                                                                            {avisoEntregaMl.rotulo}
                                                                        </Text>
                                                                    </Flex>
                                                                </TooltipSePuder>
                                                            )}
                                                            {
                                                                pedido.envio && pedido.envio.empresa &&
                                                                (
                                                                    <Text
                                                                        fontSize={"8px"}
                                                                        fontWeight={"bold"}
                                                                        textAlign='center'
                                                                        maxWidth="120px"
                                                                        whiteSpace="normal"
                                                                        overflowWrap="break-word"
                                                                    >
                                                                        {pedido.envio.empresa}
                                                                    </Text>
                                                                )
                                                            }
                                                            {
                                                                (pedido.origem == "Mercado Livre" || pedido.origem == "Mercado Shops") && pedido.pode_imprimir_etiqueta == true && (
                                                                    <>

                                                                        {loadingItemsEtiqueta[pedido.id_taga] ? (
                                                                            <Box mt={2}>
                                                                                <Spinner size="md" />
                                                                            </Box>
                                                                        ) : (
                                                                            <>
                                                                                <Box
                                                                                    id={"imprimir_etiqueta_pdf_" + pedido.id_taga}
                                                                                    bg="white"
                                                                                    p="1"
                                                                                    borderRadius="lg"
                                                                                    mt={1}
                                                                                    cursor="pointer"
                                                                                    transition="all 0.2s"
                                                                                    color="blue"
                                                                                    _hover={{
                                                                                        transform: "scale(1.05)",
                                                                                        bg: "blue",
                                                                                        color: "white",
                                                                                    }}
                                                                                    onClick={() => handleClickImprimirEtiqueta(pedido.id_taga, "pdf", pedido.id)}
                                                                                >
                                                                                    <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                                                                        <FaDownload fontSize="12px" />
                                                                                        <Text
                                                                                            ml={1}
                                                                                            fontWeight="bold"
                                                                                            fontSize="10px"
                                                                                        >
                                                                                            ETIQUETA PDF
                                                                                        </Text>
                                                                                    </Flex>
                                                                                </Box>

                                                                                <Box
                                                                                    id={"imprimir_etiqueta_zpl2_" + pedido.id_taga}
                                                                                    bg="white"
                                                                                    p="1"
                                                                                    borderRadius="lg"
                                                                                    mt={1}
                                                                                    cursor="pointer"
                                                                                    transition="all 0.2s"
                                                                                    color="blue"
                                                                                    _hover={{
                                                                                        transform: "scale(1.05)",
                                                                                        bg: "blue",
                                                                                        color: "white",
                                                                                    }}
                                                                                    onClick={() => handleClickImprimirEtiqueta(pedido.id_taga, "zpl2", pedido.id)}
                                                                                >
                                                                                    <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                                                                        <FaDownload fontSize="12px" />
                                                                                        <Text
                                                                                            ml={1}
                                                                                            fontWeight="bold"
                                                                                            fontSize="10px"
                                                                                        >
                                                                                            ETIQUETA ZPL
                                                                                        </Text>
                                                                                    </Flex>
                                                                                </Box>
                                                                            </>
                                                                        )}

                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                (pedido.origem == "TAGA" || pedido.origem == "ECOMMERCE" || pedido?.envio?.modo_envio == "Entrega a Combinar" ) && (
                                                                    <>
                                                                        <GeradorEtiquetaMelhorEnvio venda={pedido} />
                                                                    </>
                                                                )
                                                            }
                                                        </Flex>
                                                    </Td>
                                                </>
                                            )
                                            }
                                            {index > 0 && (
                                                <>
                                                    <Td pl={0}></Td>
                                                    <Td pl={0}></Td>
                                                    <Td pl={0}></Td>
                                                </>
                                            )}
                                            <Td pl={0}>
                                                <Flex flexDirection={"column"} justify="center" align="center">
                                                    {
                                                        produto.quantidade_taga > 0 && (
                                                            <Flex flexDirection={"column"} mb={2}>
                                                                <Text align='center' color="red" fontWeight={"bold"} fontSize={"12px"}>{"QTD TAGA (" + produto.quantidade_taga + ")"}</Text>
                                                                {
                                                                    produto?.local_estoque?.length > 0 && (
                                                                        <>
                                                                            <Text fontSize={"10px"} mb={0} pb={0} align='center' color="black" fontWeight={"bold"}>{"Localização: "}</Text>
                                                                            <Text fontSize={"10px"} mt={0} pt={0} align='center' color="red" fontWeight={"bold"}>{produto?.local_estoque}</Text>
                                                                        </>
                                                                    )
                                                                }
                                                            </Flex>
                                                        )
                                                    }
                                                    <Box
                                                        bg="white"
                                                        borderRadius="full"
                                                        width="20px"
                                                        height="20px"
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="center"
                                                        border="1px solid black"
                                                    >
                                                        <Text fontWeight="bold" color="blue" align='center'>
                                                            {produto.quantidade}
                                                        </Text>
                                                    </Box>
                                                </Flex>
                                            </Td>
                                            <Td pl={0}>
                                                <Flex flexDirection="column" justify="center" align="center" gap={0}>
                                                    {produto.promocao_lista_id && (
                                                        <>
                                                            <Badge colorScheme="green" fontSize="7px" mb={0.5} display="flex" alignItems="center" gap="2px" maxW="110px" cursor="pointer" onClick={(e) => { e.stopPropagation(); window.open(`/promocoes/${produto.promocao_lista_id}`, '_blank'); }} _hover={{ opacity: 0.8 }}><MdLocalOffer size={9} style={{ flexShrink: 0 }} /> <Text as="span" isTruncated fontSize="7px">{produto.promocao_lista_titulo || "PROMO"}</Text></Badge>
                                                            <Text fontSize="9px" color="gray.400" textDecoration="line-through" lineHeight="1">
                                                                R$ {parseFloat(produto.preco_original).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                            </Text>
                                                        </>
                                                    )}
                                                    <Text fontWeight="bold" align="center" color={produto.promocao_lista_id ? "green.600" : "black"}>
                                                        R$ {produto.preco?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                    </Text>
                                                </Flex>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                                <Box as="tfoot">
                                    <Tr>
                                        <Td colSpan={7} p={0} border="none">
                                            <Box bg="#edae80" borderBottomRadius="lg" overflow="hidden">
                                                <Collapse in={openPedidosFooter[pedido.id]} animateOpacity fontSize={"12px"}>
                                                    <VStack
                                                        color="white"
                                                        px={4}
                                                        pt={1}
                                                        pb={1}
                                                        spacing={0}
                                                        align="stretch"
                                                        divider={<Divider borderColor="blackAlpha.500" />}
                                                    >
                                                        <Flex py="0.5">
                                                            <Spacer />
                                                            <Box w="150px">
                                                                <Text textAlign="end">Total Itens</Text>
                                                            </Box>
                                                            <Box w="100px">
                                                                <Text textAlign="center">{pedido.total_itens}</Text>
                                                            </Box>
                                                        </Flex>

                                                        {!pedido.extrato && (
                                                        <Flex py="0.5">
                                                            <Spacer />
                                                            <Box w="150px">
                                                                <Text textAlign="end">Subtotal</Text>
                                                            </Box>
                                                            <Box w="100px">
                                                                <Text textAlign="center">
                                                                    {pedido.subtotal?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                </Text>
                                                            </Box>
                                                        </Flex>
                                                        )}

                                                        {!pedido.extrato && (
                                                        <Flex py="0.5">
                                                            <Spacer />
                                                            <Box w="150px">
                                                                <Text textAlign="end">Desconto</Text>
                                                            </Box>
                                                            <Box w="100px">
                                                                <Text textAlign="center">
                                                                    {pedido.desconto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                </Text>
                                                            </Box>
                                                        </Flex>
                                                        )}
                                                        <LinhasExtrato extrato={pedido.extrato} Linha={LinhaExtratoAntigo} />
                                                        <Spacer borderColor="blackAlpha.500" />
                                                    </VStack>
                                                </Collapse>
                                                <Flex
                                                    align="center"
                                                    py={"0.5"}
                                                    px={2}
                                                    cursor="pointer"
                                                    position="relative"
                                                    onClick={() => toggleAccordionPedidosFooter(pedido.id)}
                                                    _hover={{ bg: "#d99c6b" }}
                                                >
                                                    <Box
                                                        position="absolute"
                                                        left="50%"
                                                        transform="translateX(-50%)"
                                                        color="white"
                                                    >
                                                        {openPedidosFooter[pedido.id] ? (
                                                            <ChevronUpIcon boxSize={4} />
                                                        ) : (
                                                            <ChevronDownIcon boxSize={4} />
                                                        )}
                                                    </Box>
                                                    <Spacer />
                                                    <Box w="150px">
                                                        <Text color="white" fontWeight="bold" textAlign="end" mr={6} fontSize="sm" lineHeight="1.2">
                                                            {pedido.extrato ? 'Total realizado' : 'Total'}
                                                        </Text>
                                                    </Box>
                                                    <Box w="100px">
                                                        <Text color="white" fontWeight="bold" textAlign="center" fontSize="sm" lineHeight="1.2">
                                                            {pedido.extrato ? formatarMoedaOcorrencia(pedido.extrato.total_realizado) : pedido.total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                        </Text>
                                                    </Box>
                                                </Flex>
                                            </Box>
                                        </Td>
                                    </Tr>
                                </Box>

                            </Table>
                        </TableContainer>
                    </Box>
                </Flex>
            </Flex>
        </Flex>

        {/* Modal de Edição de Cliente */}
        <Modal isOpen={isClienteModalOpen} onClose={onClienteModalClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="md">Editar Dados do Cliente</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={3}>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm">Nome</FormLabel>
                            <Input
                                size="sm"
                                value={clienteForm.nome}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, nome: e.target.value }))}
                                placeholder="Nome completo"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel fontSize="sm">Nickname</FormLabel>
                            <Input
                                size="sm"
                                value={clienteForm.nickname}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, nickname: e.target.value }))}
                                placeholder="Nickname / apelido"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel fontSize="sm">Tipo</FormLabel>
                            <Select
                                size="sm"
                                value={clienteForm.tipo}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, tipo: e.target.value }))}
                            >
                                <option value="PF">Pessoa Física (PF)</option>
                                <option value="PJ">Pessoa Jurídica (PJ)</option>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel fontSize="sm">{clienteForm.tipo === 'PJ' ? 'CNPJ' : 'CPF'}</FormLabel>
                            <Input
                                size="sm"
                                value={clienteForm.documento}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, documento: e.target.value }))}
                                placeholder={clienteForm.tipo === 'PJ' ? '00.000.000/0000-00' : '000.000.000-00'}
                            />
                        </FormControl>
                        {clienteForm.tipo === 'PJ' && (
                            <FormControl>
                                <FormLabel fontSize="sm">Inscrição Estadual (IE)</FormLabel>
                                <Input
                                    size="sm"
                                    value={clienteForm.ie}
                                    onChange={(e) => setClienteForm(prev => ({ ...prev, ie: e.target.value }))}
                                    placeholder="000.000.000.000"
                                />
                            </FormControl>
                        )}
                        <FormControl>
                            <FormLabel fontSize="sm">E-mail</FormLabel>
                            <Input
                                size="sm"
                                value={clienteForm.email}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, email: e.target.value }))}
                                placeholder="email@exemplo.com"
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel fontSize="sm">Telefone</FormLabel>
                            <Input
                                size="sm"
                                value={clienteForm.telefone}
                                onChange={(e) => setClienteForm(prev => ({ ...prev, telefone: e.target.value }))}
                                placeholder="(00) 00000-0000"
                            />
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button size="sm" variant="ghost" onClick={onClienteModalClose} isDisabled={savingCliente}>
                        Cancelar
                    </Button>
                    <Button size="sm" colorScheme="orange" onClick={handleSalvarCliente} isLoading={savingCliente}>
                        Salvar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>

        <Modal isOpen={isEntregaModalOpen} onClose={onEntregaModalClose} size={{ base: "full", md: "xl" }} isCentered>
            <ModalOverlay />
            <ModalContent mx={{ base: 0, md: 3 }}>
                <ModalHeader fontSize="md">Confirmar Dados de Entrega</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="xs" color="gray.500" mb={3}>
                        Venda "Entrega a Combinar". Preencha os dados combinados com o cliente. Eles serão usados na emissão da etiqueta.
                    </Text>
                    {loadingEntrega ? (
                        <Flex justify="center" py={6}><Spinner color="orange.400" /></Flex>
                    ) : (
                        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
                            <GridItem colSpan={{ base: 12, md: 8 }}>
                                <FormControl isRequired>
                                    <FormLabel fontSize="sm">Nome do Cliente</FormLabel>
                                    <Input size="sm" value={entregaForm.nome} onChange={(e) => setEntregaForm(prev => ({ ...prev, nome: e.target.value }))} placeholder="Nome completo" />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 4 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Telefone</FormLabel>
                                    <Input size="sm" value={entregaForm.telefone} onChange={(e) => setEntregaForm(prev => ({ ...prev, telefone: e.target.value }))} placeholder="(00) 00000-0000" />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 4 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Tipo</FormLabel>
                                    <Select size="sm" value={entregaForm.tipo} onChange={(e) => setEntregaForm(prev => ({ ...prev, tipo: e.target.value }))}>
                                        <option value="PF">Pessoa Física (PF)</option>
                                        <option value="PJ">Pessoa Jurídica (PJ)</option>
                                    </Select>
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 8 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">{entregaForm.tipo === 'PJ' ? 'CNPJ' : 'CPF'}</FormLabel>
                                    <Input size="sm" value={entregaForm.documento} onChange={(e) => setEntregaForm(prev => ({ ...prev, documento: e.target.value }))} placeholder={entregaForm.tipo === 'PJ' ? '00.000.000/0000-00' : '000.000.000-00'} />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 4 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">CEP</FormLabel>
                                    <Input size="sm" value={entregaForm.cep} onChange={(e) => setEntregaForm(prev => ({ ...prev, cep: e.target.value }))} placeholder="00000-000" />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 8 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Logradouro</FormLabel>
                                    <Input size="sm" value={entregaForm.endereco} onChange={(e) => setEntregaForm(prev => ({ ...prev, endereco: e.target.value }))} placeholder="Rua / Av." />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 4 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Número</FormLabel>
                                    <Input size="sm" value={entregaForm.numero} onChange={(e) => setEntregaForm(prev => ({ ...prev, numero: e.target.value }))} placeholder="S/N" />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 6 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Complemento</FormLabel>
                                    <Input size="sm" value={entregaForm.complemento} onChange={(e) => setEntregaForm(prev => ({ ...prev, complemento: e.target.value }))} />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 6 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Bairro</FormLabel>
                                    <Input size="sm" value={entregaForm.bairro} onChange={(e) => setEntregaForm(prev => ({ ...prev, bairro: e.target.value }))} />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 9 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Cidade</FormLabel>
                                    <Input size="sm" value={entregaForm.cidade} onChange={(e) => setEntregaForm(prev => ({ ...prev, cidade: e.target.value }))} />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={{ base: 12, md: 3 }}>
                                <FormControl>
                                    <FormLabel fontSize="sm">UF</FormLabel>
                                    <Input size="sm" maxLength={2} value={entregaForm.uf} onChange={(e) => setEntregaForm(prev => ({ ...prev, uf: e.target.value.toUpperCase() }))} />
                                </FormControl>
                            </GridItem>
                            <GridItem colSpan={12}>
                                <FormControl>
                                    <FormLabel fontSize="sm">Transportadora / Modalidade de Envio</FormLabel>
                                    <Input size="sm" value={entregaForm.transportadora} onChange={(e) => setEntregaForm(prev => ({ ...prev, transportadora: e.target.value }))} placeholder="Ex.: Retirada, transportadora X, etc." />
                                </FormControl>
                            </GridItem>
                        </Grid>
                    )}
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button size="sm" variant="ghost" onClick={onEntregaModalClose} isDisabled={savingEntrega}>
                        Cancelar
                    </Button>
                    <Button size="sm" colorScheme="orange" onClick={handleSalvarEntrega} isLoading={savingEntrega} isDisabled={loadingEntrega}>
                        Confirmar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>

        <Modal isOpen={isPrazoModalOpen} onClose={onPrazoModalClose} size={{ base: "xs", md: "sm" }} isCentered>
            <ModalOverlay />
            <ModalContent mx={{ base: 3, md: 0 }}>
                <ModalHeader fontSize="md">Editar Prazo de Envio</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl isRequired>
                        <FormLabel fontSize="sm">Nova data limite</FormLabel>
                        <Input
                            size="sm"
                            type="datetime-local"
                            value={prazoForm}
                            min={(() => {
                                const n = new Date();
                                const p = (x) => String(x).padStart(2, '0');
                                return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}T${p(n.getHours())}:${p(n.getMinutes())}`;
                            })()}
                            onChange={(e) => setPrazoForm(e.target.value)}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button size="sm" variant="ghost" onClick={onPrazoModalClose} isDisabled={savingPrazo}>
                        Cancelar
                    </Button>
                    <Button size="sm" colorScheme="orange" onClick={handleConfirmarPrazo} isDisabled={savingPrazo}>
                        Salvar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>

        <Modal isOpen={isPrazoConfirmOpen} onClose={onPrazoConfirmClose} isCentered>
            <ModalOverlay />
            <ModalContent mx={{ base: 3, md: 0 }}>
                <ModalHeader>Confirmação</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="16" mb={4}>
                        Tem certeza de que deseja alterar o prazo de envio da venda <b>#{pedido.id_taga ?? pedido.id}</b> para <b>{prazoConfirmacaoTexto}</b>?
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                        Essa data não será mais sobrescrita pelas sincronizações automáticas do Mercado Livre.
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="green" mr={3} onClick={handleSalvarPrazo} isLoading={savingPrazo}>
                        Confirmar
                    </Button>
                    <Button variant="ghost" onClick={onPrazoConfirmClose} isDisabled={savingPrazo}>
                        Cancelar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>

        {modalListaInfo && (
            <AdicionarItemListaModal
                isOpen={!!modalListaInfo}
                onClose={() => setModalListaInfo(null)}
                itemVendaId={modalListaInfo.itemVendaId}
                fornecedorId={modalListaInfo.fornecedorId}
                fornecedorNome={modalListaInfo.fornecedorNome}
                produtoNome={modalListaInfo.produtoNome}
                statusAtual={modalListaInfo.statusAtual}
                onUpdated={handleListaUpdated}
            />
        )}
        {acoesItem.modais}
        </>
    );
};

const arePropsEqual = (prevProps, nextProps) => {
    const id = prevProps.pedido.id;

    if (prevProps.pedido !== nextProps.pedido) return false;

    // Checkbox: comparar apenas se ESTE item mudou de estado
    const wasChecked = prevProps.checkboxesState.includes(id);
    const isChecked = nextProps.checkboxesState.includes(id);
    if (wasChecked !== isChecked) return false;

    // Menu: comparar apenas se ESTE item é/era o menu aberto
    const wasMenu = prevProps.menuVisivel === id;
    const isMenu = nextProps.menuVisivel === id;
    if (wasMenu !== isMenu) return false;

    // Objetos compartilhados: comparar apenas a entrada deste item
    if (prevProps.openPedidosFooter[id] !== nextProps.openPedidosFooter[id]) return false;
    if (prevProps.loadingItemsNFML[id] !== nextProps.loadingItemsNFML[id]) return false;
    if (prevProps.loadingItemsEtiqueta[id] !== nextProps.loadingItemsEtiqueta[id]) return false;

    // Status de mensagens (badge do botao de chat) deste pedido
    const packKey = String(prevProps.pedido.pack_id);
    if ((prevProps.naoLidasPorPackId || {})[packKey] !== (nextProps.naoLidasPorPackId || {})[packKey]) return false;

    // textObs é um string compartilhado (mesma textarea) - precisa re-render apenas se Notas está visível
    if (prevProps.textObs !== nextProps.textObs) return false;

    // Campos escalares do pedido (passados individualmente para comparação rápida)
    if (prevProps.marcador !== nextProps.marcador) return false;
    if (prevProps.cotada !== nextProps.cotada) return false;
    if (prevProps.furo_estoque !== nextProps.furo_estoque) return false;
    if (prevProps.status_taga !== nextProps.status_taga) return false;
    if (prevProps.status !== nextProps.status) return false;
    if (prevProps.notaEmitida !== nextProps.notaEmitida) return false;
    if (prevProps.observacoes !== nextProps.observacoes) return false;

    if (prevProps.loadingMini !== nextProps.loadingMini) return false;
    if (prevProps.isMobile !== nextProps.isMobile) return false;

    const prevCot = prevProps.cotacaoStatus;
    const nextCot = nextProps.cotacaoStatus;
    if (prevCot !== nextCot) {
        if (!prevCot || !nextCot) return false;
        if (prevCot.status !== nextCot.status || prevCot.token !== nextCot.token) return false;
    }

    return true;
};

export default memo(VendaItem, arePropsEqual);
